import { render } from "./join.vue?vue&type=template&id=3fffbb98&ts=true"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/join.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fffbb98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fffbb98', __exports__)) {
    api.reload('3fffbb98', __exports__)
  }
  
  module.hot.accept("./join.vue?vue&type=template&id=3fffbb98&ts=true", () => {
    api.rerender('3fffbb98', render)
  })

}


export default __exports__